import {merge} from 'lodash-es'

interface WhitelabelConfig {
  /**
   * Whether to show powered by Loren Networks in the sidenav
   */
  showPoweredBy: boolean;
}

const defaults: WhitelabelConfig = {
  showPoweredBy: true,
}

export function configureWhitelabel(config: Partial<WhitelabelConfig> = {}): WhitelabelConfig {
  return merge(defaults, config);
}